/**
 * De kopteksten van de meetmoment-kolommen.
 *
 * De kaart zet elk meetmoment in een eigen kolom, maar de rijen komen uit
 * verschillende onderzoeken en die hebben niet dezelfde meetmomenten. Eén
 * kolom staat dus voor één POSITIE in het onderzoek, niet voor één meetmoment.
 *
 * Noemen alle rijen die positie hetzelfde ('Nulmeting'), dan is dat de kop —
 * dat is het gewone geval en veel duidelijker dan een nummer. Zodra ze van
 * elkaar verschillen valt de kop terug op de positie, want één van de twee
 * titels boven een gemengde kolom zetten is een onware bewering.
 *
 * @param {Array<{moments?: Array<{Title?: string}>}>} [rows]
 * @returns {Array<string>} Eén koptekst per kolom, op volgorde
 */
const momentColumnLabels = (rows) => {
    const list = rows || []
    const count = list.reduce((most, row) => Math.max(most, row?.moments?.length || 0), 0)

    return Array.from({ length: count }, (unused, index) => {
        const titles = new Set(
            list
                .map((row) => row?.moments?.[index]?.Title)
                .filter((title) => Boolean(title))
        )
        return titles.size === 1 ? [...titles][0] : `Meting ${index + 1}`
    })
}

export default momentColumnLabels
